const ParticlesBackground = () => {
  return null;
};

export default ParticlesBackground;
